<!--  ADDON DETAILS  -->

<div class="addon-details">
	<!--  ADDON MODAL HEADER  -->

	<div class="heading align-center">
		<img
			*ngIf="addon.provider_logo !== null"
			src="https://0"
			class="addon-logo"
			[attr.src]="buildAddonLogoUrl(addon.provider_logo)"
			[attr.alt]="addon.provider_name"
		/>
		<h3 [ngSwitch]="addon.description | lowercase">
			<span *ngSwitchCase="'warranty'">Protect your vehicle with one of our affordable Warranty products...</span>
			<span *ngSwitchCase="'paint protection'">Protect your vehicle with Paint Protection...</span>
			<span *ngSwitchCase="'gap insurance'">Protect your vehicle with GAP Insurance...</span>
			<span *ngSwitchCase="'service plan'">Protect your vehicle with a Service Plan...</span>
			<span *ngSwitchDefault>Choose your option...</span>
		</h3>
	</div>

	<!-- END ADDON MODAL HEADER  -->

	<!--  ADDON VIDEO  -->

	<ui-video
		*ngIf="addon.video_id !== null && addon.video_platform !== null"
		[platform]="addon.video_platform"
		[id]="addon.video_id"
		[attr.data-element-view]="
			'video__engage_configure_addon_modal__[' + addon.description + '][' + addon.video_platform + '][' + addon.video_id + ']'
		"
	></ui-video>

	<!-- END ADDON VIDEO  -->

	<!--  PRODUCT FILTERS  -->

	<div class="filter-products-section" *ngIf="hasOrganisationProducts()">
		<div class="filter-products-section-inner">
			<div class="row">
				<div class="col-xxs-15 col-sm-15 filter-options">
					<ui-slider-control
						[form]="filter_products_form"
						[form_control]="filter_products_form.controls['max_price']"
						[label]="'Max Price'"
						[display_value]="getMaxPriceLabel()"
						[prefix]="'£'"
						[min]="0"
						[step]="price_step"
						[max]="max_price"
					></ui-slider-control>
				</div>
				<div class="col-xxs-15 col-sm-15 filter-options">
					<ui-slider-control
						[form]="filter_products_form"
						[form_control]="filter_products_form.controls['max_term']"
						[label]="'Max Term'"
						[display_value]="getMaxTermLabel()"
						[min]="0"
						[step]="3"
						[max]="max_term"
						[suffix]="'months'"
					></ui-slider-control>
				</div>
			</div>
			<div class="row">
				<div class="col-xxs-15 col-sm-15 filter-options">
					<ui-slider-control
						[form]="filter_products_form"
						[form_control]="filter_products_form.controls['max_claim_limit']"
						[label]="'Claim Limit'"
						[display_value]="getClaimLimitLabel()"
						[prefix]="'£'"
						[min]="0"
						[step]="claim_step"
						[max]="max_claim_limit"
					></ui-slider-control>
				</div>
				<div class="col-xxs-15 col-sm-15 filter-submit">
					<button class="button secondary-button" (click)="setFilters()">
						Filter Results
					</button>
				</div>
			</div>
		</div>
	</div>

	<!-- END PRODUCT FILTERS  -->

	<!--  ADDON OPTIONS  -->

	<ul class="option-list">
		<li
			*ngFor="let o of getOptions(); let i = index"
			class="row"
			[ngClass]="{ checked: o.selected }"
		>
			<div
				class="col-click"
				[ngClass]="hasOrganisationProducts() ? 'col-xxs-24 col-sm-13' : 'col-xxs-30 col-sm-16'"
				[attr.data-element-click]="
					'option_row__engage_configure_addon_modal__[' + o.description + '][Set to: ' + !o.selected + ']'
				"
				(click)="toggleOption(i)"
			>
				<div class="row">
					<div
						class="col-item-title"
					>
						<i class="icon-tick checkbox pos-fg" [class.checked]="o.selected" [class.required]="o.required"></i>
						<div class="item-title">
							<div class="item-title-text" [class.item-title-bold]="o.organisation_product_id && o.has_product" [innerHTML]="getTitleText(o)"></div>
							<div *ngIf="o.organisation_product_id && o.has_product" class="item-subtitle-text">
								<p>Claim Limit: {{ o.claim_limit | currency:'GBP' }}</p>
								<p>Term: {{ o.term }} Months</p>
							</div>
							<div *ngIf="!o.financeable" class="item-subtitle-text">{{ o.description }} is non-financeable.</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-xxs-6 hidden-sm hidden-md hidden-lg hidden-xl" *ngIf="hasOrganisationProducts()">
				<ui-popover-for-product [option]="o"></ui-popover-for-product>
			</div>

			<div
				class="col-click col-xxs-30 col-sm-13"
				[attr.data-element-click]="
					'option_row__engage_configure_addon_modal__[' + o.description + '][Set to: ' + !o.selected + ']'
				"
				(click)="toggleOption(i)"
			>
				<div class="row">
					<div *ngIf="o.amount !== 0 && show_addon_finance" class="col-xxs-15 col-sm-13 col-finance text-hl">
						+ {{ o.per_month | money }}
						<small>P/M*</small>
					</div>
					<div *ngIf="o.amount !== 0 && show_addon_finance" class="col-xxs-4 col-or"><span>or</span></div>
					<div
						class="col-xxs-11 col-sm-13 col-cash text-hl"
						[ngClass]="{ 'col-xxs-offset-19 col-sm-offset-8': o.amount === 0 || !show_addon_finance }"
					>
						<span *ngIf="!vehicle.add_vat">{{ o.amount !== 0 ? '+' : '' }} {{ o.amount | money: 2:true }}</span>
						<span *ngIf="vehicle.add_vat && o.vat">
							{{ o.net_amount !== 0 ? '+' : '' }} {{ o.net_amount | money: 2:true }}
							<small *ngIf="o.net_amount !== 0">+ VAT</small>
						</span>
						<span *ngIf="vehicle.add_vat && !o.vat">
							{{ o.amount !== 0 ? '+' : '' }} {{ o.amount | money: 2:true }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-sm-3 hidden-xxs hidden-xs" *ngIf="hasOrganisationProducts()">
				<ui-popover-for-product [option]="o"></ui-popover-for-product>
			</div>
		</li>
	</ul>

	<!-- END ADDON OPTIONS  -->

	<!--  FINANCE DISCLAIMER  -->

	<div *ngIf="show_addon_finance" class="written-content padded align-center">
		<p class="small-print">
			* Based on {{ selected_quote?.facility_type || '' | uppercase }} Representative Example having
			{{ selected_quote.number_of_regular_payments | pluralise : 'regular payment' : '+s' }}.
		</p>
	</div>

	<!--  END FINANCE DISCLAIMER  -->
</div>

<!-- END ADDON DETAILS  -->
